import { jsx } from "react/jsx-runtime";
import Accordion from "../../../../../dataDisplay/Accordion/Accordion.js";
import LinkListInner, { L as LinkListStyles } from "./LinkListInner.js";
const LinkListMiddle = (props) => {
  var _a;
  const { links, resolveChevron, openMenu } = props;
  const resolvedItems = links.items;
  if (links.special) {
    resolvedItems == null ? void 0 : resolvedItems.push({
      header: links.special.text,
      href: links.special.href,
      chevron: links.special.chevron,
      mod: [{ "data-special-action": "true" }],
      links: []
    });
  }
  return /* @__PURE__ */ jsx(
    Accordion,
    {
      closedIcon: "Plus",
      openIcon: "Minus",
      className: LinkListStyles.accordionLevel2,
      items: ((_a = links.items) == null ? void 0 : _a.map((item, itemIndex) => ({
        label: item.header,
        value: `${item.header}${itemIndex}`,
        chevron: resolveChevron(item.links, item.href, item.chevron),
        href: item.href,
        mod: item.mod,
        content: item.links && item.links.length > 0 && /* @__PURE__ */ jsx(LinkListInner, { links: item.links, openMenu })
      }))) || []
    }
  );
};
export {
  LinkListMiddle as default
};
